"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = require("react-select");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _oxygenAvatar = _interopRequireDefault(require("@8x8/oxygen-avatar"));

var _oxygenCheckbox = _interopRequireDefault(require("@8x8/oxygen-checkbox"));

var _oxygenRadio = _interopRequireDefault(require("@8x8/oxygen-radio"));

var _oxygenConstants = require("@8x8/oxygen-constants");

var _oxygenConfig = require("@8x8/oxygen-config");

var Styled = _interopRequireWildcard(require("../styled"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Option = function Option(_ref) {
  var children = _ref.children,
      _ref$selectProps = _ref.selectProps,
      hasIcons = _ref$selectProps.hasIcons,
      hasCheckbox = _ref$selectProps.hasCheckbox,
      testId = _ref$selectProps.testId,
      rest = _objectWithoutProperties(_ref, ["children", "selectProps"]);

  var iconProps = rest.data.iconProps,
      isSelected = rest.isSelected,
      isDisabled = rest.isDisabled,
      isMulti = rest.isMulti;

  var renderItem = function renderItem() {
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, hasIcons && /*#__PURE__*/_react["default"].createElement(Styled.AvatarIcon, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_AVATAR_ICON")), /*#__PURE__*/_react["default"].createElement(_oxygenAvatar["default"], _extends({
      size: _oxygenConstants.avatarSize.size2xsmall,
      testId: testId
    }, iconProps))), /*#__PURE__*/_react["default"].createElement(Styled.OptionWrapper, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_OPTION_WRAPPER")), children));
  };

  var renderItemWithCheckbox = function renderItemWithCheckbox() {
    return isMulti ? /*#__PURE__*/_react["default"].createElement(Styled.CheckboxWrapper, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_CHECKBOX_WRAPPER")), /*#__PURE__*/_react["default"].createElement(_oxygenCheckbox["default"], {
      isChecked: isSelected,
      label: renderItem(),
      testId: testId
    }), /*#__PURE__*/_react["default"].createElement(Styled.OptionCheckboxLayer, _extends({
      isDisabled: isDisabled
    }, (0, _oxygenConfig.getTestAttributes)("".concat(testId, "_OPTION_CHECKBOX_LAYER"))))) : /*#__PURE__*/_react["default"].createElement(_oxygenRadio["default"], {
      isChecked: isSelected,
      label: renderItem()
    });
  };

  return /*#__PURE__*/_react["default"].createElement(_reactSelect.components.Option, _extends({}, rest, {
    isDisabled: isDisabled
  }), hasCheckbox ? renderItemWithCheckbox() : renderItem());
};

Option.propTypes = {
  children: _propTypes["default"].node,
  selectProps: _propTypes["default"].object,
  isDisabled: _propTypes["default"].bool
};
Option.defaultProps = {
  children: null,
  selectProps: undefined,
  isDisabled: false
};
var _default = Option;
exports["default"] = _default;